
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'Gallery',
  components: { SpeedkitPicture },
  props: {
    title: {
      required: true,
      type: String,
    },
    description: {
      required: true,
      type: String,
    },
    items: {
      type: Array,
      require: true,
    },
  },
}
